import {MuWidget} from "mu-widget/lib/MuWidget";
import {t} from "../translate";
import {isElementInViewport, onElementInViewport, tryParseInt} from "../utils";
// import {DelayedSingleLauncher} from "mu-widget/lib/utils/DelayedSingleLauncher";
import {FoundActivityVariants} from "../types";
import {DelayedSingleRun} from "mu-js-utils/lib/DelayedSingleRun";
// import {DelayedSingleRun} from "mu-js-utils/lib/DelayedSingleRun";

export interface InfiniteSelectorItem {
    id: any;
    name: string;
    icon?: string | null;
    category?: any;
}

export interface InfiniteSelectorCategory {
    id: any;
    name: string;
}

export type InfiniteSelectorDataLoader = (
    filters: { fulltext?: string|null, letter?: string|null, categoryId?: number|null },
    loadCategories: boolean,
    limitFrom: number,
    limitCount: number
) => Promise<FoundActivityVariants>;

export class InfiniteSelector extends MuWidget {
    public items: InfiniteSelectorItem[] = [];
    public categories: InfiniteSelectorCategory[] = [];
    public selectedId: any = null;
    public letter: string|null = null;
    public page: number = 0;
    protected firstLoad = true;
    protected lastLetter = '';
    protected dataLoader: InfiniteSelectorDataLoader|null = null;

    // @ts-ignore
    declare ui: {
        category: HTMLSelectElement;
        fulltext: HTMLInputElement;
        list: HTMLElement;
        letters: HTMLElement;
        scrollDetector: HTMLElement;
    };
    private loadObserver: IntersectionObserver|null = null;
    /**
     * Podle BE je to poslední dávka
     * @protected
     */
    protected isLastLoad: boolean = false;
    private itemPerPage: number = 100;

    beforeIndex() {
        this.container.classList.add('infinity-selector');
        this.muAppendContent(`
            <div class="infinity-selector__category">
                <select mu="category#categories:@options"></select>
            </div>
            <div class="infinity-selector__fulltext">
                <input type="search" mu="fulltext" placeholder="${t('selectorSearch')}" />
            </div>
            <div class="infinity-selector__body">
                <div class="infinity-selector__list">
                    <div mu="list">
                        <div mu=":.@listHeader" class="infinity-selector__group-header"><span mu="letter"></span></div>
                        <div mu=":InfinitySelectorItem@listItem" class="infinity-selector__item"></div>
                    </div>
                    <div mu="scrollDetector" class="infinity-selector__load-indicator">...načítám ...</div>
                </div>
                <div class="infinity-selector__letters-wrap">
                    <button mu="letterAll" class="infinity-selector__letter infinity-selector__letter--all">${t('selectorAllLetters')}</button>
                    <nav class="infinity-selector__letters" mu="letters#letters:@foreach">
                        <span mu=":InfinitySelectorLetter@letter" class="infinity-selector__letter"></span>
                    </nav>
                </div>
            </div>
        `);
        this.muRegisterEvent('select');
    }

    afterIndex() {
        this.loadData();
    }

    async loadData(nextLoad: boolean = false) {
        if (!this.dataLoader) return;
        const filter = {
            letter: this.letter,
            fulltext: this.ui.fulltext.value,
            categoryId: tryParseInt(this.ui.category.value),
        };
        if (nextLoad) {
            if (this.isLastLoad) return;
            this.page++;
        } else {
            this.page = 0;
            this.isLastLoad = false;
        }
        const data = await this.dataLoader(
            filter,
            this.firstLoad,
            this.page,
            this.itemPerPage,
        );
        this.ui.scrollDetector.innerText = data.isLastLoad ? '' : t('genLoading');
        this.isLastLoad = data.isLastLoad;
        this.firstLoad = false;
        if (data.letters) this.muBindData({ letters: data.letters });
        if (data.categories) this.muBindData({
            categories: [
                { text: t('selectorAllCategories'), value: '' },
                ...data.categories,
            ]
        });

        if (!nextLoad) this.ui.list.innerHTML = '';

        for (const item of data.items) {
            const letter = item.group ?? item.name[0].toUpperCase();
            if (letter !== this.lastLetter) {
                this.muWidgetFromTemplate(
                    'listHeader',
                    'list',
                ).ui.letter.textContent = letter;
                this.lastLetter = letter;
            }
            this.muWidgetFromTemplate(
                'listItem',
                'list',
            ).muBindData(item);
        }

        if (!this.loadObserver) {
            this.loadObserver = onElementInViewport(
                this.ui.scrollDetector,
                async () => {
                    do {
                        await this.loadData(true);
                    } while(isElementInViewport(this.ui.scrollDetector) && !this.isLastLoad)
                },
                false
            );
        }

    }

    category_change() {
        this.loadData();
    }

    setDataLoader(dataLoader: InfiniteSelectorDataLoader) {
        this.dataLoader = dataLoader;
        this.loadData();
    }

    protected fulltextDR = new DelayedSingleRun(
        100,
        () => this.loadData()
    );
    fulltext_input() {
        this.fulltextDR.send();
    }

    letterAll_click() {
        this.letter = null;
        this.loadData();
    }

    setLetter(letter: string) {
        this.letter = letter;
        this.loadData();
    }

    selectItem(item: any) {
        this.muDispatchEvent('select', item);
    }
}

export class InfinitySelectorLetter extends MuWidget
{
    // @ts-ignore
    muParent: InfiniteSelector;
    // @ts-ignore
    letter: string;
    muBindData(letter: string) {
        this.letter = letter;
        this.container.textContent = letter;
    }

    container_click() {
        this.muParent.setLetter(this.letter);
    }
}

export class InfinitySelectorItem extends MuWidget
{
    // @ts-ignore
    declare muParent: InfiniteSelector;
    beforeIndex() {
        this.muAppendContent(`
            <span class="infinity-selector__item-icon"></span>
            <span mu="#name" class="flex-grow-1"></span>
        `);
    }

    public item: any;

    muBindData(srcData: any) {
        this.item = srcData;
        super.muBindData(srcData);
        const iconEl = this.container.querySelector<HTMLElement>('.infinity-selector__item-icon');
        if (iconEl) {
            iconEl.className = srcData.icon
                ? `icon--${srcData.icon} infinity-selector__item-icon`
                : 'infinity-selector__item-icon';
        }
    }

    container_click() {
        this.muParent.selectItem(this.item);
    }
}